import React from "react";
import styled, {css} from "styled-components";
import WPLink from "components/shared/WPLink";
import {media} from "utils/Media";

const StepedStyled = styled.div`
  height: 100%;

  .error {
    color: red;
  }


  ${props => props.simpleWithButton && css`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  `}


  h4 {
    font-family: ${props => props.theme.font.family.bold};
    color: ${(props) => props.theme.colors.primary};
    font-weight: 500;
    font-size: 40px;
    text-transform: uppercase;
    margin-bottom: 0;

    ${props => props.simpleWithButton && css`
      margin-bottom: 1rem;
    `}
  }

  h5 {
    font-family: ${props => props.theme.font.family.black};
    color: ${(props) => props.theme.colors.black};
    font-weight: 500;
    font-size: 24px;
    text-transform: uppercase;
    margin-bottom: 0;

    ${props => props.simpleWithButton && css`
      margin-bottom: 1rem;
    `}
  }

  p {
    font-size: 15px;
    color: #000;
    font-family: ${props => props.theme.font.family.heading}
  }

  .simple-link {
    color: ${(props) => props.theme.colors.primary};
  }

  @media ${media.md} {
    h4 {
      font-size: 50px;
    }

    p {
      font-size: 1rem;
      margin: 0.5rem 0 1.5rem 0;
    }
  }
  @media ${media.xl} {
    h4 {
      font-size: 60px;
    }

    > p {
      font-size: 20px;
      margin: 0.5rem 0 1.5rem 0;
      line-height: 25px;

    }

  }

  form {
    margin-top: 1rem;

    ${(props) =>
            props.$successStep &&
            css`
              background: red !important;
              display: flex;
              align-items: center;
              justify-content: center;
            `}
    .input-wrapper {
      div {
        position: relative;
        border-radius: 0;

        input[type="text"],
        input[type="email"],
        input[type="date"],
        select {
          width: 100%;
          border-radius: 0 !important;
          padding: 0.75rem 0.5rem;
          margin-bottom: 0.5rem;
          outline: none;
          border: solid black 1px;
          height: 45px;

          &::placeholder {
            font-size: 12px;
            font-weight: 400;
            color: #757575;
            @media ${media.ls} {
              font-size: 15px;
            }
            @media ${media.md} {
              font-size: 18px;
            }
          }

          @media ${media.md} {
            height: 50px;
          }
        }

        select {
          font-size: 0.65rem;
          outline: none;
          @media ${media.ls} {
            font-size: 15px;
          }
        }

        input[type="date"] {
          font-size: 0.95rem;

          &::placeholder {
            font-size: 0.5rem;
          }
        }
      }

      label {
        font-weight: 500;
        font-size: 14px;
        margin-bottom: 0.35rem;
        display: block;
        color: #000;
        @media ${media.ls} {
          font-size: 15px;
        }
        @media ${media.md} {
          font-size: 1rem;
        }
      }

      svg {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 0.75rem;
        right: 0.5rem;
        fill: red;
        display: none;
        @media ${media.md} {
          top: 1rem;
          right: 1rem;
        }
      }
    }

    .error {
      label {
        color: red !important;
      }

      input {
        border: solid red 2px !important;
      }

      svg {
        display: block;
      }
    }

    //? remove margin from last input
    .last {
      margin-bottom: 0 !important;
    }
  }

  .buttons {
    display: flex;
    gap: 1rem;
    margin: 2rem 0 1rem 0;
    justify-content: space-between;
    align-items: flex-end;
    padding-bottom: 2rem;

    button {
      width: 200px;
      background: none;
      border: ${(props) => props.theme.colors.secondary} solid 2px;
      padding: 2rem 1rem;

      span {
        color: ${(props) => props.theme.colors.primary};
        font-family: ${(props) => props.theme.font.family.bold};
        font-size: 1.25rem;
        text-transform: uppercase;
      }

      @media ${media.lg} {
        padding: 1.85rem 1rem;
      }
      @media ${media.xl} {

        span {
          font-size: 22px;
        }
      }
    }

    .filler {
      visibility: hidden;
      width: 50%;
      padding: 0.85rem 0.75rem;
    }

    .prev {
      background: none;
      border: none;
      display: flex;
      align-items: left;
      justify-content: flex-start;

      span {
        color: #fff;
        line-height: 0;
      }
    }

    .next {
      background: none;
      border: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      &:before {
        content: "";
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        border: solid ${(props) => props.theme.colors.primary} 2px;
        position: absolute;
        z-index: 1;
      }

      &:hover {
        &:before {
          border: solid ${(props) => props.theme.colors.primary} 4px;
        }
      }

      span {
        color: ${(props) => props.theme.colors.primary};
        line-height: 0;
      }
    }

    @media ${media.s} {
      width: 100%;
      left: 0;
      right: 0;
    }
  }
`;

const StepWrapper = ({children, step, ...props}) => {

  console.log(props)
    return (
        <StepedStyled {...props}>
            <div className="inner-wrap">
              {props.$successStep ? (
                  ""
              ) : (
                  <>
                      <h4>{props.blockSignupTitle}</h4>
                      <h5>
                          {props.blockSignupSubtitle}
                      </h5>
                  </>
              )}
              {!props.simpleWithButton && (
                <>{children}</>
              )}
              {props.blockSignupLink && props.simpleWithButton &&  (
                <WPLink url={props.blockSignupLink.url} target={props.blockSignupLink.target} button color="black" className="my-3" id="popuplink">
                  {props.blockSignupLink.title}
                </WPLink>
              )}
            </div>
        </StepedStyled>
    );
};

export default StepWrapper;

const StepCounterStyled = styled.section`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    border-radius: 50%;
    height: 12px;
    width: 12px;
    background-color: ${(props) => props.theme.colors.white};
    @media ${media.md} {
      width: 15px;
      height: 15px;
    }
  }

  span {
    width: 30px;
    height: 3px;
    background-color: #000;
    border-radius: 20px;
    @media ${media.md} {
      width: 50px;

    }
  }

  .active {
    background-color: ${(props) => props.theme.colors.secondary};
  }
`;

const StepCounter = ({step}) => (
    <StepCounterStyled>
        <div className={step === 0 ? "active" : ""}></div>
        <span/>
        <div className={step === 1 ? "active" : ""}></div>
    </StepCounterStyled>
);
